import { Router } from '@angular/router';

import { AuthService } from './auth.service';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginGuardService {
  private router = inject(Router);
  private auth = inject(AuthService);

  canActivate() {
    // console.log('Login service: ' + this.auth.isUserLoggedIn());
    if (this.auth.isUserLoggedIn()) {
      // console.log('ok');
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
